import { InfoLabel } from 'bold-ui'

import { ResultadoEspecificoPrenatal } from '../../model-resultadosExames'
import { mountIdadeGestacionalValue } from '../../util-resultadosExames'

interface ResultadoExamePrenatalViewProps {
  value: ResultadoEspecificoPrenatal
}

export const ResultadoExamePrenatalView = (props: ResultadoExamePrenatalViewProps) => {
  const { value } = props

  return <InfoLabel title='Resultado'>{mountIdadeGestacionalValue(value)}</InfoLabel>
}
